import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import TouchableOpacity from '/component/base/TouchableOpacity';
import {Rank} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import {styles} from './ListItem.style';

export const ListItem = ({
  label = null,
  onPress = noop,
  prefix = null,
  readonly = false,
  style: styleProp = {},
  suffix = null,
  testID = null,
  accessibilityLabel,
  accessibilityHint,
  onFocus = noop,
  accessible = !readonly,
  focusable = !readonly,
}: any) => {
  const Component = readonly ? View : TouchableOpacity;
  return (
    <Component
      {...testProperties(testID, true)}
      style={{...styles.base, ...(styleProp.base || {})}}
      onPress={onPress}
      onFocus={onFocus}
      accessible={accessible}
      focusable={focusable}
      accessibilityRole={readonly ? undefined : 'button'}
      accessibilityLabel={accessibilityLabel}
      accessibilityHint={accessibilityHint}
      accessibilityElementsHidden={false}
      pointerEvents="auto">
      {!!prefix && (
        <View
          {...testProperties(Rank.listItemPrefix)}
          style={{...styles.prefix, ...(styleProp.prefix || {})}}
          accessible={false}>
          {prefix}
        </View>
      )}
      <View
        {...testProperties(Rank.listItemLabel)}
        style={{...styles.label, ...(styleProp.label || {})}}
        accessible={false}>
        {label}
      </View>
      {!!suffix && (
        <View
          {...testProperties(Rank.listItemSuffix)}
          style={{...styles.suffix, ...(styleProp.suffix || {})}}
          accessible={false}>
          {suffix}
        </View>
      )}
    </Component>
  );
};

export default ListItem;
